import React from 'react';
import linkedinBlack from '../../assets/images/linkedin-black.png';
import member1 from '../../assets/images/team-member-1.jpeg';
import member2 from '../../assets/images/team-member-2.jpeg';
import member3 from '../../assets/images/team-member-3.jpeg';
import member4 from '../../assets/images/team-member-4.jpeg';

const Leadership = () => {
  return (  
    <div className="mt-5 leadership">
      <div className="text-center">
        <span className="text-primary fs-36">Leadership</span><br></br>
        <span className="text-gray fs-14">Our leaders are perseverant individuals who nurture<br></br> excellence. </span>
      </div>
      <div className="team">
        <div className="row">
          <div className="col-md-3 col-xs-12 member">
            <div className="team-members">
              <div className="team-member-img">
                <img src={member1} alt="Member 1" className="rounded-circle" width="120px" height="120px" />
              </div>
              <div className="team-member-description pt-5">
                <span className="fs-22 font-weight-bold">Rajeev Shroff</span><br></br>
                <span className="fs-15 font-weight-bold">Fractional CEO</span><br></br>
                <a href="https://www.linkedin.com/in/rajeevshroff/"  rel="noopener noreferrer" target="_blank"><img src={linkedinBlack} alt="Linkedin icon" className="mt-10" /></a>
              </div>
            </div>            
          </div>
          <div className="col-md-3 col-xs-12 member">
          <div className="team-members">
              <div className="team-member-img">
                <img src={member2} alt="Member 2" className="rounded-circle" width="120px" height="120px" />
              </div>
              <div className="team-member-description pt-5">
                <span className="fs-22 font-weight-bold">Iffat Aziz</span><br/>
                <span className="fs-15 font-weight-bold">Director, Business Operations</span><br/>
                <a href="https://www.linkedin.com/in/iffat-aziz-24090b3/" target="_blank" rel="noopener noreferrer"><img src={linkedinBlack} alt="Linkedin icon" className="mt-10" /></a>
              </div>
            </div>   
          </div>
          <div className="col-md-3 col-xs-12 member">
          <div className="team-members">
              <div className="team-member-img">
                <img src={member3} alt="Member 3" className="rounded-circle" width="120px" height="120px" />
              </div>
              <div className="team-member-description pt-5">
                <span className="fs-22 font-weight-bold">Devender Reddy</span><br />
                <span className="fs-15 font-weight-bold">Director Review Operations</span><br />
                <a href="https://www.linkedin.com/in/devender-reddy-4a289b2b/" target="_blank" rel="noopener noreferrer"><img src={linkedinBlack} alt="Linkedin icon" className="mt-10" /></a>
              </div>
            </div>   
          </div> 
          <div className="col-md-3 col-xs-12 member">
          <div className="team-members">
              <div className="team-member-img">
                <img src={member4} alt="Member 4" className="rounded-circle" width="120px" height="120px" />
              </div>
              <div className="team-member-description pt-5">
                <span className="fs-22 font-weight-bold">Vanaja Kumari Amireddy</span><br />
                <span className="fs-15 font-weight-bold">Sr. Manager Client Services</span><br />
                <a href="https://www.linkedin.com/in/vanajaamireddy/" target="_blank" rel="noopener noreferrer"><img src={linkedinBlack} alt="Linkedin icon" className="mt-10" /></a>
              </div>
            </div>   
          </div>          
        </div>
      </div>
    </div>
  );
}
 
export default Leadership;